import { CountryFilters } from "@services/countries/types";
import { asBoolean, SLFilterToSearch } from "./common";

export const countriesStatusMap: {
  [K in CountriesStatusFilter]:
    | { key: keyof CountryFilters; value: boolean }
    | undefined;
} = {
  All: undefined,
  Online: { key: "status.reachable", value: true },
  Offline: { key: "status.reachable", value: false },
  "Monitoring Stalled": {
    key: "status.stale",
    value: true,
  },
  "Monitoring Paused": {
    key: "status.pauseMonitoringStatus.paused",
    value: true,
  },
  "API Error": { key: "status.apiError", value: true },
  "Login Error": { key: "status.loginError", value: true },
  "In a Call": { key: "status.inCall", value: true },
};

export const widgetFilterToSLFilter = (
  filters: (WidgetFilter | FilterDefinition)[] = []
): CountryFilters => {
  let mapped: CountryFilters = {};
  filters.forEach((f) => {
    switch (f.filterType as FilterTypes) {
      case "status":
        const statusValue = f.payload
          ? Array.isArray(f.payload)
            ? f.payload
            : [f.payload]
          : [f.filterValue];
        statusValue.forEach((value) => {
          const countryStatus =
            countriesStatusMap[value as CountriesStatusFilter];
          if (countryStatus !== undefined) {
            mapped[countryStatus.key] = countryStatus.value as any;
          }
        });
        break;
      default:
        break;
    }
  });

  return mapped;
};

export const SLFilterToWidgetFilter = (
  slFilters: CountryFilters
): FilterDefinition[] => {
  const filters: FilterDefinition[] = [];
  const statusPayload: string[] = [];
  if (slFilters["status.reachable"] !== undefined)
    statusPayload.push(
      slFilters["status.reachable"] === true ? "Online" : "Offline"
    );
  if (slFilters["status.apiError"] !== undefined)
    statusPayload.push("API Error");
  if (slFilters["status.loginError"] !== undefined)
    statusPayload.push("Login Error");
  if (slFilters["status.inCall"] !== undefined) statusPayload.push("In a Call");
  if (slFilters["status.stale"] !== undefined)
    statusPayload.push("Monitoring Stalled");
  if (slFilters["status.pauseMonitoringStatus.paused"] !== undefined)
    statusPayload.push("Monitoring Paused");
  if (statusPayload.length > 0)
    filters.push({
      filterType: "status",
      filterValue: "",
      payload: statusPayload,
    });
  return filters;
};

export const searchToSLFilter = (params: URLSearchParams): CountryFilters => {
  const filters: CountryFilters = {};

  asBoolean(filters, params, [
    "status.reachable",
    "status.inCall",
    "status.stale",
    "status.apiError",
    "status.loginError",
    "status.pauseMonitoringStatus.paused",
  ]);

  return filters;
};

export default {
  fromDefinition: {
    toSL: widgetFilterToSLFilter,
    toSearchParams: (filters?: (WidgetFilter | FilterDefinition)[]) =>
      SLFilterToSearch(widgetFilterToSLFilter(filters)),
  },
  fromSL: {
    toDefinition: SLFilterToWidgetFilter,
    toSearchParams: (r: CountryFilters) => SLFilterToSearch(r),
  },
  fromSearchParams: {
    toSL: searchToSLFilter,
    toDefinition: (params: URLSearchParams) =>
      SLFilterToWidgetFilter(searchToSLFilter(params)),
  },
};
